module.exports = __webpack_public_path__ + "b41fa7db130cd92a80e7da1876e088f3.pdf";